import { render, staticRenderFns } from "./NavRouter.vue?vue&type=template&id=0fc17fe8&"
import script from "./NavRouter.vue?vue&type=script&lang=js&"
export * from "./NavRouter.vue?vue&type=script&lang=js&"
import style0 from "./NavRouter.vue?vue&type=style&index=0&id=0fc17fe8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports